import React, { useState } from "react";
import Logo from "../assets/SVGs/Logo";
import {
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import VisibilityIcon from "../assets/SVGs/Login/VisibilityIcon";
import VisibilityOffIcon from "../assets/SVGs/Login/VisibilityOffIcon";
import { LoginAPI } from "../api/login";
import { hashPassword } from "../componets/helper";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
  });
  const [formError, setFormError] = useState({
    email: "",
    password: "",
  });
  const [loginError, setLoginError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleError = (formObj = loginForm) => {
    const temp = { ...formError };

    if ("email" in formObj) {
      temp.email = formObj.email ? "" : "Login is required!";
    }
    if ("password" in formObj) {
      temp.password = formObj.password ? "" : "Password is required!";
    }

    setFormError({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleChange = (key, value) => {
    setLoginForm((prevState) => ({ ...prevState, [key]: value }));
    handleError({ [key]: value });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  const handleSubmit = async (e) => {
    if (handleError()) {
      e.preventDefault();
      setIsLoading(true);
      setLoginError(false);

      const { email, password } = loginForm;

      if (email && password) {
        try {
          const hashedPassword = await hashPassword(password);
          const res = await LoginAPI.login(email, hashedPassword);

          if (res.content === "OK" && res.principal) {
            login(res.principal);

            if (res.principal.role === "ADMIN") {
              navigate("/membership");
            } else {
              navigate("/member/membership");
            }
          } else {
            setLoginError(true);
          }
        } catch (error) {
          setLoginError(true);
          console.error(error.response?.status || error.message);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
        console.error("Email and password are required.");
      }
    }
  };

  return (
    <div className="flex align-center justify-center login-container ">
      <div className="form-container flex align-center justify-center flex-col">
        <Logo />

        <div className="flex align-center justify-center flex-col text-container">
          <h2>Welcome to the Tyler Referral Network</h2>
          <p>Please log in to access the network</p>
        </div>

        <div className="text-fleld-container flex flex-col">
          <TextField
            margin="normal"
            fullWidth
            id="email"
            label="Login*"
            name="email"
            autoComplete="email"
            autoFocus
            value={loginForm.email}
            onChange={(e) => handleChange("email", e.target.value)}
            className="login-textField "
            onKeyUp={handleKeyPress}
            size="small"
            error={formError.email !== ""}
            helperText={formError.email}
          />

          <FormControl
            variant="outlined"
            className="login-textField"
            sx={{
              marginTop: "16px",
            }}
            size="small"
            error={formError.password !== ""}
            helperText={formError.password}
          >
            <InputLabel htmlFor="outlined-adornment-password">
              Password*
            </InputLabel>
            <OutlinedInput
              margin="normal"
              required
              fullWidth
              id="password"
              type={showPassword ? "text" : "password"}
              autoComplete="current-password"
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    onMouseUp={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? (
                      <VisibilityOffIcon className="icon-color" />
                    ) : (
                      <VisibilityIcon className="icon-color" />
                    )}
                  </IconButton>
                </InputAdornment>
              }
              label="Password"
              value={loginForm?.password}
              onChange={(e) => handleChange("password", e.target.value)}
              className="login-textField "
              onKeyUp={handleKeyPress}
            />{" "}
            {formError.password !== "" && (
              <FormHelperText>{formError.password}</FormHelperText>
            )}
          </FormControl>
        </div>
        <Button
          type="submit"
          className="login-btn flex align-center justify-center"
          variant="contained"
          color="primary"
          disabled={isLoading}
          onClick={(e) => handleSubmit(e)}
        >
          {isLoading ? (
            <CircularProgress
              sx={{
                color: "#fff",
                width: "20px!important",
                height: "20px!important",
              }}
              disableShrink
              variant="indeterminate"
            />
          ) : (
            "Sign in"
          )}
        </Button>
        <div className="forgot-password-wrapper">
          <Link to="/forgot-password" className="forgot-password-link">
            Forgot Password?
          </Link>
        </div>

        {loginError && (
          <p className="error-message">Invalid login or password.</p>
        )}
      </div>
    </div>
  );
};

export default Login;
